// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__dMDfR","backdrop":"Notifications_backdrop__3mlCq","field":"Notifications_field__IaXkr","label":"Notifications_label__mKKjK"};